module.exports = __webpack_public_path__ + "img/charging-labels-fr.47a25820.png";